import { msg, tr } from '../../i18n/msg';
import { entityText } from '../../i18n/entityText';

/**
 * Общие подписи игры (тип награды, часть тела, редкость) — ключи i18n с английским дефолтом.
 * Значения enum ('HEAD', 'GREEN', 'COINS') остаются идентификаторами, переводится только показ.
 */

export const MODULE_TYPE_LABELS = {
  HEAD: msg('module_type.head', 'Head'),
  BODY: msg('module_type.body', 'Body'),
  HAND: msg('module_type.hand', 'Hand'),
  LEG: msg('module_type.leg', 'Leg'),
  LEFT_HAND: msg('module_type.left_hand', 'Left hand'),
  RIGHT_HAND: msg('module_type.right_hand', 'Right hand'),
  LEFT_LEG: msg('module_type.left_leg', 'Left leg'),
  RIGHT_LEG: msg('module_type.right_leg', 'Right leg'),
};

/** Короткие подписи слотов героя (L. Hand) */
export const MODULE_SLOT_SHORT_LABELS = {
  HEAD: msg('module_slot.head', 'Head'),
  BODY: msg('module_slot.body', 'Body'),
  LEFT_HAND: msg('module_slot.left_hand', 'L. Hand'),
  RIGHT_HAND: msg('module_slot.right_hand', 'R. Hand'),
  LEFT_LEG: msg('module_slot.left_leg', 'L. Leg'),
  RIGHT_LEG: msg('module_slot.right_leg', 'R. Leg'),
};

export const RARITY_LABELS = {
  GREEN: msg('rarity.green', 'Green'),
  BLUE: msg('rarity.blue', 'Blue'),
  PURPLE: msg('rarity.purple', 'Purple'),
  GOLD: msg('rarity.gold', 'Gold'),
};

export const REWARD_TYPE_LABELS = {
  COINS: msg('reward.coins', 'Coins'),
  TICKETS: msg('reward.ticket', 'Ticket'),
  TICKET: msg('reward.ticket', 'Ticket'),
  TON: 'GRAM',
  TON_COINS: 'GRAM',
  MODULE: msg('reward.module', 'Module'),
  CHARACTER_MODULE: msg('reward.character_module', 'Character Module'),
  CHEST: msg('reward.chest', 'Chest'),
  KEY: msg('reward.key', 'Key'),
  LIVES: msg('reward.lives', 'Lives'),
};

export const moduleTypeLabel = (t, type) => tr(t, MODULE_TYPE_LABELS[type]) || type;
export const moduleSlotLabel = (t, type) => tr(t, MODULE_SLOT_SHORT_LABELS[type]) || moduleTypeLabel(t, type);
export const rarityLabel = (t, rarity) =>
  tr(t, RARITY_LABELS[String(rarity || '').toUpperCase()]) || rarity;
export const rewardTypeLabel = (t, type) => tr(t, REWARD_TYPE_LABELS[type]) || type;

/** «Green Chest» / «Зелёный сундук» */
export const chestLabel = (t, rarity) => (rarity
  ? t('reward.chest_of_rarity', '{{rarity}} Chest', { rarity: rarityLabel(t, rarity) })
  : rewardTypeLabel(t, 'CHEST'));

export const keyLabel = (t, rarity) => (rarity
  ? t('reward.key_of_rarity', '{{rarity}} Key', { rarity: rarityLabel(t, rarity) })
  : rewardTypeLabel(t, 'KEY'));

/**
 * Подпись награды в попапе / ленте спинов. Приоритет: labelMsg (явный ключ) → сущность (entity) →
 * по типу (сундук/ключ по редкости, часть по moduleType, монеты/билеты/GRAM) → label как есть.
 */
export function rewardLabel(t, reward) {
  if (!reward) return '';
  if (reward.labelMsg) return tr(t, reward.labelMsg);
  if (reward.entity?.id) {
    return entityText(t, reward.entity.prefix, reward.entity.id, reward.entity.field || 'name', reward.label);
  }
  switch (reward.type) {
    case 'CHEST': return reward.chestRarity ? chestLabel(t, reward.chestRarity) : (reward.label || chestLabel(t));
    case 'KEY': return reward.keyRarity ? keyLabel(t, reward.keyRarity) : (reward.label || keyLabel(t));
    case 'MODULE': {
      const type = reward.moduleType || reward.raw?.moduleType;
      if (reward.moduleData?.id && reward.moduleData?.name) {
        return entityText(t, 'character_module', reward.moduleData.id, 'name', reward.moduleData.name);
      }
      if (type && MODULE_TYPE_LABELS[type]) return moduleTypeLabel(t, type);
      return reward.label && reward.label !== 'Character Module' ? reward.label : rewardTypeLabel(t, 'CHARACTER_MODULE');
    }
    case 'COINS':
    case 'TICKETS':
    case 'TON':
    case 'LIVES':
      return rewardTypeLabel(t, reward.type);
    default:
      return reward.label || reward.type;
  }
}

/** Имя части героя ({id, name, baseModuleId?}): у сплавленной части перевод берётся по каталожной (baseModuleId). */
export const partName = (t, module, fallback = '') => {
  if (!module?.name) return fallback;
  return entityText(t, 'character_module', module.baseModuleId || module.id, 'name', module.name);
};
